<template>
    <v-row justify="center">
        <v-dialog v-model="ui.dialog" persistent max-width="600">
            <v-card class="pa-4">
                <v-card-title>
                    Crear lista de precio
                </v-card-title>
                <v-card-text class="pb-0">
                    <v-form
                        ref="form"
                        v-model="ui.valid"
                        lazy-validation
                        @submit.prevent="store()"
                    >
                        <v-row>
                            <v-col cols="12" class="pb-0">
                                <v-text-field
                                    dense
                                    outlined
                                    label="Nombre"
                                    autocomplete="off"
                                    v-model="layout.name"
                                    :rules="[v.required]"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                    <v-btn
                        color="primary"
                        text
                        @click="ui.dialog = false"
                        :disabled="ui.storing"
                    >
                        cancelar
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="store()"
                        :loading="ui.storing"
                        :disabled="!ui.valid"
                    >
                        enviar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import axios from "axios";
import { V } from "@/main";
import { EventBus } from "@/main";
import { mapState } from "vuex";

export default {
    data() {
        return {
            layout: { name: null },

            v: V,

            ui: {
                valid: true,
                dialog: false,
                storing: false,
            },
        };
    },

    created() {
        EventBus.$on("PriceListCreate", () => {
            this.ui.dialog = true;
        });
    },

    methods: {
        async store() {
            try {
                if (this.$refs.form.validate()) {
                    this.ui.storing = true;

                    let response = await axios.post(
                        `${process.env.VUE_APP_API_SERVER}/auth/pricelist`,
                        this.layout,
                        {
                            headers: {
                                Authorization: `Bearer ${this.acount.token}`,
                            },
                        }
                    );

                    EventBus.$emit("PriceListCreated", response.data.data);

                    this.ui.dialog = false;

                    this.$refs.form.reset();
                }
            } catch (error) {
                EventBus.$emit("Error", { error: error, errorsShow: true });
            } finally {
                this.ui.storing = false;
            }
        },
    },

    computed: {
        ...mapState(["acount"]),
    },
};
</script>

<style lang="css" scoped></style>
